(() => {
  'use strict';
  const CORE = ['wood', 'cafe', 'focus', 'pop', 'calm', 'soft', 'comfort', 'conversation', 'flexible', 'compact', 'storage', 'budget'];
  const PREFIX = 'ace:inquiry-intent:v1:';
  const TTL = 24 * 60 * 60 * 1000;
  function selectedKeys(value, allowed) {
    return [...new Set(String(value || '').slice(0, 1000).split(',').map(key => key.trim()).filter(key => allowed.includes(key)))].slice(0, 12);
  }
  function validId(value) { return typeof value === 'string' && (CORE.includes(value) || /^purpose_[a-f0-9]{8}$/.test(value)); }
  function safeLabel(value) { return typeof value === 'string' && value.trim().length > 0 && value.length <= 180 && !/[\u0000-\u001f\u007f]/.test(value) ? value.trim() : null; }
  function resolveIntent(data, id) {
    if (!validId(id) || !data || data.version !== 1 || !data.byId || !Object.prototype.hasOwnProperty.call(data.byId, id)) return null;
    const item = data.byId[id];
    if (!item || !(item.canonicalId === null || CORE.includes(item.canonicalId))) return null;
    return safeLabel(item.label);
  }
  function restoreIntent(record, id, now) {
    if (!record || record.version !== 1 || record.id !== id || !validId(id) || !Number.isFinite(record.time) || now < record.time || now - record.time > TTL) return null;
    return safeLabel(record.label);
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { selectedKeys, validId, safeLabel, resolveIntent, restoreIntent }; return; }
  if (window.aceConsultationKeywordPrefillReady) return;
  window.aceConsultationKeywordPrefillReady = true;
  const touched = new WeakSet();
  let generation = 0;
  document.addEventListener('change', event => {
    const field = event.target.closest?.('[data-ace-consult-keywords]');
    if (field) touched.add(field);
  }, true);
  window.addEventListener('pagehide', () => { generation += 1; });
  function cacheKey(id) { return PREFIX + location.pathname + ':' + id; }
  function setGoal(field, label) {
    const input = field.querySelector('[data-ace-selected-intent]');
    const wrap = field.querySelector('[data-ace-selected-intent-wrap]');
    if (!input || !wrap || input.value) return;
    input.value = label;
    input.disabled = false;
    wrap.hidden = false;
  }
  async function goal(field, id, initial, attempt) {
    const input = field.querySelector('[data-ace-selected-intent]');
    if (!input || field.dataset.serverResponse === 'true') return;
    if (input.value) {
      input.disabled = false;
      field.querySelector('[data-ace-selected-intent-wrap]').hidden = false;
      return;
    }
    let label = null;
    try { label = restoreIntent(JSON.parse(sessionStorage.getItem(cacheKey(id)) || 'null'), id, Date.now()); } catch (_) {}
    if (label) { setGoal(field, label); return; }
    if (!initial || field.dataset.intentAttempted === 'true') return;
    field.dataset.intentAttempted = 'true';
    try {
      const url = new URL(field.dataset.intentLabelsUrl, location.href);
      if (url.protocol !== 'https:' || ![location.hostname, 'cdn.shopify.com'].includes(url.hostname) || url.username || url.password) return;
      const response = await fetch(url.href, { credentials: 'omit', redirect: 'error' });
      if (!response.ok) return;
      const text = await response.text();
      if (text.length > 100000) return;
      label = resolveIntent(JSON.parse(text), id);
      if (!label || attempt !== generation || field.dataset.serverResponse === 'true' || input.value) return;
      setGoal(field, label);
      try { sessionStorage.setItem(cacheKey(id), JSON.stringify({ version: 1, id, label, time: Date.now() })); } catch (_) {}
    } catch (_) {}
  }
  function prefill(event) {
    const navigation = performance.getEntriesByType?.('navigation')?.[0];
    const initial = !event?.persisted && navigation?.type !== 'back_forward' && navigation?.type !== 'reload';
    const params = new URL(location.href).searchParams;
    const value = params.get('ace_keywords');
    const id = params.getAll('ace_intent').length === 1 ? params.get('ace_intent') : null;
    document.querySelectorAll('[data-ace-consult-keywords]').forEach(field => {
      if (field.dataset.postedSuccessfully === 'true' && validId(id)) { try { sessionStorage.removeItem(cacheKey(id)); } catch (_) {} }
      if (validId(id)) goal(field, id, initial, generation);
      if (!initial || !value || field.dataset.prefilled === 'true' || field.dataset.serverResponse === 'true' || touched.has(field)) return;
      field.dataset.prefilled = 'true';
      const inputs = Array.from(field.querySelectorAll('input[data-ace-keyword]'));
      const selected = selectedKeys(value, inputs.map(input => input.dataset.aceKeyword));
      inputs.forEach(input => { if (selected.includes(input.dataset.aceKeyword)) input.checked = true; });
    });
  }
  if (document.readyState === 'complete') prefill();
  else window.addEventListener('pageshow', prefill, { once: true });
})();
